import { PresentationTemplateType } from '@/types/schema';

export enum PresentationTemplateTableVariant {
  Tenant = 'tenant',
  User = 'user',
}

export const presentationTemplateTypeByTableVariant: Record<
  PresentationTemplateTableVariant,
  PresentationTemplateType
> = {
  [PresentationTemplateTableVariant.Tenant]:
    PresentationTemplateType.TenantTemplate,
  [PresentationTemplateTableVariant.User]:
    PresentationTemplateType.UserTemplate,
};
